export const REVIEW_SUMMARY = {
  rating: '5.0',
  count: 84,
  label: 'Google reviews',
  lastVerified: 'September 2026',
  sourceUrl:
    'https://reviews.birdeye.com/preferred-service-heating-cooling-and-caring-165382424005351',
};

const verifiedReviews = [
  {
    name: 'Gregory Page',
    rating: 5,
    quote: 'The level of professionalism and expertise his techs had was amazing.',
    sourceLabel: 'Google review via Birdeye',
    sourceUrl:
      'https://reviews.birdeye.com/preferred-service-heating-cooling-and-caring-165382424005351',
  },
  {
    name: 'Fer O.',
    rating: 5,
    quote:
      'Someone being on time, being honest about the service and your options, and completing the work at the time of service!',
    sourceLabel: 'Google review via Experience.com',
    sourceUrl: 'https://www.experience.com/reviews/preferred-22042969',
  },
  {
    name: 'Clark B.',
    rating: 5,
    quote: 'Steve has always done a great job taking care of all of our HVAC needs!',
    sourceLabel: 'BBB customer review',
    sourceUrl:
      'https://www.bbb.org/us/ut/south-jordan/profile/heating-and-air-conditioning/preferred-service-heating-cooling-and-air-purity-inc-1126-22168762',
  },
];

export default verifiedReviews;
